import { STEP_ORDER } from '../constants/fanStyle';
import type { FAN_STYLE_OPTIONS } from '../constants/fanStyle';

interface FanStyleProgressBarProps {
  currentStep: keyof typeof FAN_STYLE_OPTIONS;
}

const PROGRESS_BAR_WIDTH = 110;

const FanStyleProgressBar = ({ currentStep }: FanStyleProgressBarProps) => {
  const currentStepIndex = STEP_ORDER.indexOf(currentStep);
  const progressWidth = ((currentStepIndex + 1) / STEP_ORDER.length) * PROGRESS_BAR_WIDTH;

  return (
    <div className="relative mt-[24px]">
      <div className="h-[7px] rounded-[10px] w-[110px] bg-separator2 dark:bg-separator1" />
      <div
        className="absolute top-0 left-0 rounded-[10px] h-[7px] overflow-hidden transition-all duration-500 ease-out"
        style={{
          background:
            'radial-gradient(50% 50% at 50% 50%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0.00) 100%), linear-gradient(270deg, #94A5F9 0%, #5CDBF6 30%, #FFE175 50%, #D671F6 80%, #9F9DF9 100%)',
          backgroundSize: '110px 7px',
          width: `${progressWidth}px`
        }}
      />
    </div>
  );
};

export default FanStyleProgressBar;
